import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import data from "../utils/ListEnrolledCourses.json";
import { HiOutlineAcademicCap } from "react-icons/hi2";
import Materials from "../components/Session/Materials";
import Tests from "../components/Session/Tests";
import RelatedContent from "../components/Session/RelatedContent";
import Notes from "../components/Session/Notes";
import VideoStreaming from "../components/Session/VideoStreaming";

const Session = () => {
	const { LiveDetailId } = useParams();
	const [selectedTab, setSelectedTab] = useState("Materials");
	// const [selectedChat, setSelectedChat] = useState("Group Chat");
	const [showLeft, setShowLeft] = useState(false);
	const [setShowRight] = useState(false);
	const course = data.courses.find(
		(course) => course.id === parseInt(LiveDetailId)
	);

	const handleTabClick = (tab) => setSelectedTab(tab);
	// const handleChatPick = (tab) => setSelectedChat(tab);

	const toggleLeftSection = () => {
		setShowLeft(!showLeft);
	};

	// const toggleRightSection = () => {
	// 	setShowRight(!showRight);
	// };

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth >= 1024) {
				setShowLeft(false);
				setShowRight(false);
			}
		};

		window.addEventListener("resize", handleResize);
		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [setShowRight]);

	if (!course) {
		return (
			<div className="text-center text-red-500">Course not found.</div>
		);
	}

	return (
		<div>
			<main className="flex min-h-screen relative gap-2 p-4 bg-white mt-20">
				{/* Left Section Toggle Icon */}
				<div className="absolute top-4 left-4 z-50 lg:hidden bg-mainColor p-1 rounded-xl">
					<HiOutlineAcademicCap
						size={30}
						className="text-white cursor-pointer"
						onClick={toggleLeftSection}
					/>
				</div>

				{/* Left Section: Materials, Tests, etc. */}
				<section
					className={`lg:block bg-blue-600 left-4 w-3/4 rounded-lg lg:w-1/4 overflow-auto ${
						showLeft
							? "absolute z-40 top-9 left-0 bg-gradient-to-r from-[#80aaff] to-[#4a90e2]  h-[92%] lg:h-[96%]"
							: "hidden"
					}`}
				>
					<div className="tabs-wrapper p-2 m-2">
						<div className="tabs flex gap-4">
							<div
								className={`tab p-2 cursor-pointer ${
									selectedTab === "Materials"
										? "bg-[#2e4a8d] rounded-lg text-white"
										: "text-white"
								}`}
								onClick={() => handleTabClick("Materials")}
							>
								Materials
							</div>
							<div
								className={`tab p-2 cursor-pointer ${
									selectedTab === "Tests"
										? "bg-[#2e4a8d] rounded-lg text-white"
										: "text-white"
								}`}
								onClick={() => handleTabClick("Tests")}
							>
								Tests
							</div>
							<div
								className={`tab p-2 cursor-pointer ${
									selectedTab === "Notes"
										? "bg-[#2e4a8d] rounded-lg text-white"
										: "text-white"
								}`}
								onClick={() => handleTabClick("Notes")}
							>
								Notes
							</div>
						</div>
					</div>
					<div className="tab-content p-2 m-2">
						{selectedTab === "Materials" && <Materials />}
						{selectedTab === "Tests" && <Tests />}
						{selectedTab === "Notes" && <Notes />}
					</div>
				</section>

				{/* Video Section */}
				<section className="flex-1 p-4 bg-blue-600 rounded-lg overflow-auto">
					<VideoStreaming />
				</section>
			</main>

			<div className="bg-white rounded-lg shadow-lg p-6 mt-6">
				<div className="flex flex-col md:flex-row items-center md:items-start">
					<img
						src={course.image}
						alt={course.title}
						className="w-48 h-48 object-cover rounded-full shadow-md md:mr-6"
					/>
					<div className="text-center md:text-left mt-4 md:mt-0">
						<h1 className="text-3xl font-bold text-gray-800">
							{course.title}
						</h1>
						<p className="text-gray-600 mt-2">
							{course.description}
						</p>
						<p className="text-gray-500 mt-2">
							<strong>Teacher:</strong> {course.teacher}
						</p>
						<p className="text-gray-500 mt-2">
							<strong>Start Time:</strong>{" "}
							{new Date(course.startTime).toLocaleString()}
						</p>
					</div>
				</div>
			</div>

			<div className="mt-2">
				<RelatedContent />
			</div>
		</div>
	);
};

export default Session;
